<template>
  <div class="edit-highlights-section" :class="{ 'edit-highlights-section--is-pc': isPc }">
    <div
      class="edit-highlights-section__mask"
      :class="{ 'edit-highlights-section__mask--active': true }"
    />

    <div class="edit-highlights-section__inner">
      <transition name="slide" appear>
        <new-highlights-input-section
          v-if="highlightData"
          :videoPlayerKey="videoPlayerKey"
          class="edit-highlights-section__create"
          :screenOrientationType="screenOrientationType"
          :editType="editType"
          :highlightData="highlightData"
          :createHighlight="createHighlight"
          @close="handleCloseClicked"
          @onClickCommentCancel="handleCommentCancelClicked"
          @onSaveHighlight="saveHighlight"
          @showHighlightPreviewVideoPlayer="showHighlightPreviewVideoPlayer"
          @hideHighlightPreviewVideoPlayer="hideHighlightPreviewVideoPlayer"
        />
      </transition>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import NewHighlightsInputSection from '@/components/RaceVideoPage/RaceVideoHighlightsPane/NewHighlightsInputSection.vue'
import { EditHighlightData } from '@/store/stores/pageStore/RaceVideoPage/RaceVideoPageStore'
import DeviceInfo from '@/util/DeviceInfo'
import HighlightDocument from '@/store/stores/collectionModule/documents/highlight/HighlightDocument'
import { HighlightOperationType } from '@/components/RaceVideoPage/RaceVideoHighlightsPane.vue'

export default defineComponent({
  name: 'EditHighlightSection',
  components: {
    NewHighlightsInputSection,
  },
  props: {
    /**
     * 画面向き
     */
    screenOrientationType: {
      type: String,
      default: 'portrait-primary',
    },
    editType: {
      type: String as PropType<HighlightOperationType>,
      default: 'create',
    },
    /**
     * ハイライトの作成・編集で使用するデータ
     */
    highlightData: {
      type: Object as PropType<EditHighlightData>,
    },
    /**
     * ハイライト作成・編集モーダルの表示/非表示
     */
    createHighlight: {
      type: Boolean,
      default: false,
    },
    /**
     * プレビュー動画プレイヤー再描画用のキー
     */
    videoPlayerKey: {
      type: Number,
      required: true,
    },
  },
  setup(_, { emit }) {
    const isPc = DeviceInfo.isForPC()
    const handleCloseClicked = () => {
      emit('onClickClose')
    }

    const handleCommentCancelClicked = () => {
      emit('onClickCommentCancel')
    }

    return {
      isPc,
      handleCloseClicked,
      handleCommentCancelClicked,
    }
  },
  methods: {
    /**
     * 動画プレイヤーを表示する
     */
    showHighlightPreviewVideoPlayer() {
      this.$emit('showHighlightPreviewVideoPlayer')
    },
    /**
     * 動画プレイヤーを非表示にする
     */
    hideHighlightPreviewVideoPlayer() {
      this.$emit('hideHighlightPreviewVideoPlayer')
    },
    /**
     * ハイライトを保存する
     */
    saveHighlight(
      comment: string,
      highlightData: HighlightDocument,
      postX: boolean,
      postInstagram: boolean,
    ) {
      this.$emit('onSaveHighlight', comment, highlightData, postX, postInstagram)
    },
  },
})
</script>

<style scoped lang="scss">
.edit-highlights-section {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  z-index: 40;

  &__mask {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    background: $black50;
    width: 100%;
    height: 100vh;
    z-index: 41;
    opacity: 0;
    pointer-events: none;
    transition: opacity ease 0.3s;

    &--active {
      opacity: 1;
      pointer-events: auto;
    }
  }

  &--is-pc {
    height: 100%;

    .edit-highlights-section__inner {
      position: absolute;
      top: 0;
      right: 0;
      width: 375px;
      height: calc(100% - 220px);
    }
  }

  .race-video-highlights-pane--landscape-primary &,
  .race-video-highlights-pane--landscape-secondary & {
    width: 230px;
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: all ease 0.3s;
}

.slide-enter,
.slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
